var _rect, _path, _rect2, _path2, _rect3, _rect4, _rect5, _path3, _path4, _rect6, _path5, _path6, _path7, _rect7, _rect8, _g, _rect9, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRetrievingSetsStepThree(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 464,
    height: 231,
    viewBox: "0 0 464 231",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 364,
    y: 89,
    width: 50,
    height: 50,
    rx: 25,
    fill: "#FCFCFC",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M396.586 101.453C396.913 101.125 397.444 101.125 397.771 101.453L401.754 105.436C402.081 105.763 402.082 106.293 401.755 106.621L397.772 110.608C397.444 110.936 396.914 110.936 396.586 110.609C396.259 110.282 396.258 109.751 396.585 109.424L399.14 106.866H395.744C395.364 106.866 395.029 107.013 394.811 107.242L394.798 107.255L388.129 113.948C388.074 114.006 388.015 114.062 387.955 114.115L394.559 120.742L394.572 120.756C394.79 120.984 395.125 121.132 395.505 121.132H399.141L396.586 118.577C396.259 118.25 396.259 117.719 396.586 117.391C396.913 117.064 397.444 117.064 397.771 117.391L401.754 121.375C402.081 121.702 402.082 122.232 401.755 122.56L397.772 126.547C397.444 126.875 396.914 126.875 396.586 126.548C396.259 126.221 396.258 125.69 396.585 125.363L399.137 122.808H395.505C394.703 122.808 393.922 122.499 393.366 121.919L386.697 115.226L386.684 115.213C386.466 114.985 386.127 114.837 385.751 114.837H377.318L377.296 114.837H376.838C376.375 114.837 376 114.462 376 113.999C376 113.536 376.375 113.16 376.838 113.16H385.99C386.367 113.16 386.706 113.012 386.923 112.784L386.936 112.771L393.605 106.078C394.161 105.499 394.942 105.19 395.744 105.19H399.138L396.586 102.638C396.259 102.311 396.259 101.78 396.586 101.453Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 194,
    width: 34.0014,
    height: 42,
    rx: 5.10021,
    transform: "rotate(90 42 194)",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9512 223H63.9512V199L41.9512 199",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 57.9512,
    y: 204,
    width: 4,
    height: 4,
    transform: "rotate(90 57.9512 204)",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 57.9512,
    y: 214,
    width: 4,
    height: 4,
    transform: "rotate(90 57.9512 214)",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 122.779,
    y: 10.1511,
    width: 310.442,
    height: 193.651,
    rx: 1.5,
    stroke: "#FCFCFC",
    strokeOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M442.372 210.791V3C442.372 1.89543 441.477 1 440.372 1H115.628C114.523 1 113.628 1.89544 113.628 3.00001L113.628 210.791",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M240.024 215.96L240.126 216.01H240.241H278H312.962H313.064L313.157 215.97L324.252 211.291H463.5V215.798C463.5 223.507 457.251 229.756 449.542 229.756H106.458C98.7491 229.756 92.5 223.507 92.5 215.798V211.291H230.337L240.024 215.96Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 142,
    y: 89,
    width: 50,
    height: 50,
    rx: 25,
    fill: "#FCFCFC",
    fillOpacity: 0.05
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.65 119.697C167.283 120.045 166.715 120.045 166.349 119.697L162.576 115.924C162.209 115.557 162.209 114.989 162.576 114.623C162.74 114.44 162.997 114.348 163.217 114.348C163.436 114.348 163.675 114.44 163.858 114.623L166.074 116.839V103.925C166.074 103.412 166.477 103.009 166.99 103.009C167.503 103.009 167.906 103.412 167.906 103.925V116.839L170.123 114.623C170.489 114.275 171.057 114.275 171.423 114.623C171.79 114.989 171.79 115.575 171.423 115.924L167.65 119.697ZM176.15 118.726C176.15 118.213 176.553 117.81 177.066 117.81C177.579 117.81 177.982 118.213 178 118.726V122.921C178 124.057 177.084 124.991 175.985 124.991H158.015C156.897 124.991 156 124.057 156 122.921V118.726C156 118.213 156.403 117.81 156.915 117.81C157.428 117.81 157.831 118.213 157.831 118.726V122.921C157.831 123.068 157.923 123.159 158.015 123.159H175.967C176.058 123.159 176.15 123.068 176.15 122.921V118.726Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M205 113.5C204.724 113.5 204.5 113.724 204.5 114C204.5 114.276 204.724 114.5 205 114.5L205 113.5ZM213.354 114.354C213.549 114.158 213.549 113.842 213.354 113.646L210.172 110.464C209.976 110.269 209.66 110.269 209.464 110.464C209.269 110.66 209.269 110.976 209.464 111.172L212.293 114L209.464 116.828C209.269 117.024 209.269 117.34 209.464 117.536C209.66 117.731 209.976 117.731 210.172 117.536L213.354 114.354ZM205 114.5L213 114.5L213 113.5L205 113.5L205 114.5Z",
    fill: "#FCFCFC",
    fillOpacity: 0.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M343 113.5C342.724 113.5 342.5 113.724 342.5 114C342.5 114.276 342.724 114.5 343 114.5L343 113.5ZM351.354 114.354C351.549 114.158 351.549 113.842 351.354 113.646L348.172 110.464C347.976 110.269 347.66 110.269 347.464 110.464C347.269 110.66 347.269 110.976 347.464 111.172L350.293 114L347.464 116.828C347.269 117.024 347.269 117.34 347.464 117.536C347.66 117.731 347.976 117.731 348.172 117.536L351.354 114.354ZM343 114.5L351 114.5L351 113.5L343 113.5L343 114.5Z",
    fill: "#FCFCFC",
    fillOpacity: 0.3
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 98,
    width: 104,
    height: 32,
    rx: 16,
    fill: "#FCFCFC",
    fillOpacity: 0.05
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 110,
    width: 80,
    height: 8,
    rx: 4,
    fill: "#FCFCFC",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_218_13053)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 110,
    width: 65,
    height: 8,
    rx: 4,
    fill: "#575F9E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_218_13053",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 238,
    y: 110,
    width: 65,
    height: 8
  }, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 110,
    width: 65,
    height: 8,
    rx: 4,
    fill: "#3C458F"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_218_13053)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.131 110H301.825L305.492 118H294.798L291.131 110Z",
    fill: "#020203",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.465 110H283.159L286.826 118H276.132L272.465 110Z",
    fill: "#020203",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.794 110H264.488L268.155 118H257.461L253.794 110Z",
    fill: "#020203",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.128 110H245.822L249.489 118H238.795L235.128 110Z",
    fill: "#020203",
    fillOpacity: 0.15
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_218_13053",
    x: 234,
    y: 106,
    width: 73,
    height: 16,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_218_13053"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_218_13053",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.282917 0 0 0 0 0.33622 0 0 0 0 0.808333 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_218_13053"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetrievingSetsStepThree);
export default __webpack_public_path__ + "static/media/retrieving-sets-step-three.d8e997567211d1ee340436c0adad6cab.svg";
export { ForwardRef as ReactComponent };